import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialog, ConfirmationDialogProps } from '../../../../lib/components';

type Props = Omit<ConfirmationDialogProps, 'variant' | 'title' | 'contentText'> & {
  type: 'location' | 'costCenter' | 'department' | 'groups';
};

export const ConfirmDeleteDialog: FC<Props> = (props) => {
  const { t } = useTranslation('confirm_dialogs');

  return (
    <ConfirmationDialog
      {...props}
      variant="warning"
      title={t('DELETE_TITLE', { context: props.type.toLowerCase() })}
      contentText={t('DELETE_CONTENT', { context: props.type.toLowerCase() })}
    />
  );
};
